export default __webpack_public_path__ + "static/media/@blogdoceapego.344a4b69.png";